import { createContext, useContext } from 'react';

import type {
  DateTimePreference,
  DateOrder,
  DateSeparator,
  HourCycle,
} from './dateTimePreference.ts';

export interface DateTimeFormatContextValue {
  readonly preference: DateTimePreference;
  setDateOrder: (order: DateOrder) => void;
  setSeparator: (separator: DateSeparator) => void;
  setHourCycle: (cycle: HourCycle) => void;
}

export const DateTimeFormatContext = createContext<DateTimeFormatContextValue | null>(null);

/**
 * Throws outside the provider, matching `theme/themeContext.ts`'s `useTheme` — a silent default
 * would mean a control that appears to change the preference and does not.
 */
export function useDateTimeFormat(): DateTimeFormatContextValue {
  const value = useContext(DateTimeFormatContext);
  if (value === null) {
    throw new Error('useDateTimeFormat must be used inside <DateTimeFormatProvider>');
  }
  return value;
}
